import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';
import { expVal } from '@confluence/feature-experiments';

export function getMultiMacroQueryBlocklistFF(): string[] {
	let blocklist = StatsigConfigurations.getStringList(
		'confluence_frontend_macros_query_blocklist',
		[
			'include',
			'jirachart',
			'jiraroadmap',
			'ui-button',
			'contentbylabel',
			'excerpt-include',
			'tasks-report-macro',
			'blog-posts',
			'section',
			'table-filter',
			'children',
			'pagetree',
			'detailssummary',
			'decisionreport',
		],
	);
	if (expVal('confluence_frontend_ssr_include_macro_exp', 'isEnabled', false)) {
		blocklist = blocklist.filter((macro) => macro !== 'include');
	}
	return String(blocklist).split(',');
}

export function canUseMultiMacroQuery(
	extensionKey: string | undefined,
	isNested2pBodiedExtension = false,
): boolean {
	return (
		!isNested2pBodiedExtension && !getMultiMacroQueryBlocklistFF().includes(extensionKey || '')
	);
}
